var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-editions-edition",class:{
    'tw-flex tw-flex-col': true,
    'tw-border tw-border-gray-200 tw-border-solid tw-rounded-md':
      _vm.context !== 'meta' ||
      _vm.plugin.editions.length > 1 ||
      !_vm.isPluginEditionFree(_vm.edition),
    'tw-p-8 tw-text-center': _vm.context !== 'meta',
    'tw-p-4':
      _vm.context === 'meta' &&
      (_vm.plugin.editions.length > 1 || !_vm.isPluginEditionFree(_vm.edition)),
  }},[_c('div',{staticClass:"description tw-flex-1"},[(_vm.plugin.editions.length > 1)?[_c('div',{staticClass:"tw-text-xl tw-font-bold tw-mb-4"},[_vm._v("\n        "+_vm._s(_vm.edition.name)+"\n      ")])]:_vm._e(),_vm._v(" "),(_vm.context !== 'meta')?[(
          _vm.plugin.editions.length > 1 &&
          _vm.edition.features &&
          _vm.edition.features.length > 0
        )?_c('ul',{staticClass:"tw-text-left tw-mt-8 tw-mb-8"},_vm._l((_vm.edition.features),function(feature,key){return _c('li',{key:key,staticClass:"tw-my-2",class:{
            'tw-border-t': key === 0,
          }},[_c('c-icon',{attrs:{"icon":"check"}}),_vm._v("\n          "+_vm._s(feature.name)+"\n\n          "),(feature.description)?_c('info-hud',[_vm._v("\n            "+_vm._s(feature.description)+"\n          ")]):_vm._e()],1)}),0):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('plugin-actions',{attrs:{"plugin":_vm.plugin,"edition":_vm.edition}}),_vm._v(" "),(!_vm.isPluginEditionFree(_vm.edition) && !_vm.plugin.abandoned)?_c('p',{staticClass:"tw-text-gray-700"},[_vm._v("\n    "+_vm._s(_vm._f("t")('Plus {renewalPrice}/year for updates after one year.','app', {
          renewalPrice: _vm.$options.filters.currency(_vm.edition.renewalPrice),
        }))+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }